const ModalType = {
  ALERT: 'alert',
  PLATMAP: 'platmap',
  CONTACT_INFO: 'contact-information',
  THANK_YOU: 'thank-you',
  CROPPING_TOOL: 'cropping-tool',
  PLAN_DETAILS: 'plan-details',
};

const OrientationType = {
  PORTRAIT_PRIMARY: 'portrait-primary',
  LANDSCAPE_PRIMARY: 'landscape-primary',
};

const StatusCode = {
  BADREQUEST: 400,
};

const Settings = {
  MIN_PERCENTAGE_TO_SHOW_CIRCLE: 60,
  GRAPH_MAX_LENGTH: 349.5177307128906,
  GRAPH_MAX_PERCENTAGE: 100,
  GRAPH_MIN_PERCENTAGE: 0,
  WEB_MIN_SVG_SCALE: 1,
  WEB_DEFAULT_SVG_SCALE: 6,
  WEB_MAX_SVG_SCALE: 9,
  MOBILE_MIN_SVG_SCALE: 1,
  MOBILE_DEFAULT_SVG_SCALE: 6,
  MOBILE_MAX_SVG_SCALE: 9,
  MAP_MIN_SVG_SCALE: 10,
  MAP_DEFAULT_SVG_SCALE: 17,
  MAP_MAX_SVG_SCALE: 20,
  PORTRAIT_MIN_HEIGHT: 667,
  PORTRAIT_MAX_WIDTH: 575,
  LANDSCAPE_MAX_HEIGHT: 749.5,
  LANDSCAPE_MIN_WIDTH: 576,
  TABLET_PORTRAIT_MIN_WIDTH: 768,
  IOS_MIN_ORIENTATION: -90,
  IOS_MAX_ORIENTATION: 90,
  TOP_OUTER_HEIGHT_MOBILE: 18,
  TOP_OUTER_HEIGHT_TABLET: 25,
  BOTTOM_OUTER_HEIGHT_MOBILE: 10,
  BOTTOM_OUTER_HEIGHT_TABLET: 15,
  SESSION_KEY: 'SalesPlatPrint',
  MaxValue: Number.POSITIVE_INFINITY,
  MinValue: Number.NEGATIVE_INFINITY,
};

const Status = {
  AVAILABLE: 'Available',
  QUICK_MOVE_IN: 'Quick Move-In',
  QMI: 'QMI',
  SOLD: 'Sold',
  SOLD_CONTINGENCY: 'Sold Contingency',
  SOLD_PENDING: 'Sold Pending',
  SOLD_CLOSED: 'Sold Closed',
  RESERVED: 'Reserved',
  RESERVED_LOT_HOLD: 'Reserved Lot Hold',
  MODEL: 'Model',
  FUTURE_HOME: 'Future Home',
};

const Scalers = {
  TN: 'tn',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XL: 'xl',
  XXL: 'xxl',
  ORIGINAL: 'original',
};
const ImageWidth = {
  TN: '300',
  SMALL: '501',
  MEDIUM: '700',
  LARGE: '900',
  XL: '1600',
  XXL: '1920',
};

const PreAreaNameUrl = 'new-homes';

const TimeSlots = [
  '10:00 AM',
  '11:00 AM',
  '12:00 PM',
  '1:00 PM',
  '2:00 PM',
  '3:00 PM',
  '4:00 PM',
];

const DreesCustomHomesAreas = ['austin', 'dallas-ft-worth', 'houston'];

const SortOptions = {
  PRICE: 'price',
  PLAN: 'plan',
};

const HomePlanSortOptions = [
  {
    value: 'Price High to Low',
    sortField: SortOptions.PRICE,
    sortDirection: -1,
  },
  {
    value: 'Price Low to High',
    sortField: SortOptions.PRICE,
    sortDirection: 1,
  },
  {
    value: 'Plan Name A - Z',
    sortField: SortOptions.PLAN,
    sortDirection: 1,
  },
  {
    value: 'Plan Name Z - A',
    sortField: SortOptions.PLAN,
    sortDirection: -1,
  },
];

const QmiDaysFilter = [
  {
    value: 'Immediate',
    days: 7,
  },
  {
    value: 'Within 30 Days',
    days: 30,
  },
  {
    value: 'Within 60 Days',
    days: 60,
  },
  {
    value: 'Within 90 Days',
    days: 90,
  },
  {
    value: 'Beyond 90 days',
    days: Number.POSITIVE_INFINITY,
  },
];

const SliderChange = 50000;

const OrderHomeTypeList = ['Single Family', 'Townhome', 'Patio Home', 'Condo'];

const OrderFooter = [
  'Available',
  'Quick Move-In',
  'Reserved',
  'Future Home',
  'Sold',
  'Model',
];
const SalesLandFooterOrder = [
  'Available',
  'Reserved Lot Hold',
  'QMI',
  'Sold Contingency',
  'Sold Pending',
  'Sold Closed',
  'Future Home',
  'Model',
];

const SaleLegendStatusOrder = [
  'Available',
  'Reserved Lot Hold',
  'QMI',
  'Sold Contingency',
  'Sold Pending',
  'Sold Closed',
  'Future Home',
  'Model',
  'Amenity'
];
const LandLegendStatusOrder = [
  'Available',
  'Reserved Lot Hold',
  'QMI',
  'Not Available',
  'Sold Closed',
  'Sold Contingency',
  'Sold Pending',
  'Model/Leaseback',
  'Amenity'
];

const UrlFilterList = {
  MAX_PRICE: 'max_price',
  MIN_PRICE: 'min_price',
  PLAN_NAME: 'plan_name',
  HOME_TYPE: 'home_type',
  QMI_FILTER: 'qmi_filter',
  SORT_BY: 'sort_by',
  NEIGHBORHOOD: 'neighborhood',
  LOT: 'lot',
};

const FutureData = {
  PLAN_MARKET_NAME: 'plan_market_name',
  PLAN_NAME: 'plan_name',
  PRICE: 'price',
  IMAGE: 'image',
  ADDRESS: 'address',
  IS_FUTURE_PLAN: 'isFuturePlan',
  JOB_NUMBER: 'job_number',
  NEIGHBORHOOD_CODE: 'neighborhood_code',
  NEIGHBORHOOD_NAME: 'neighborhood_name',
  ELEVATION: 'elevation',
  PLAN_TYPE: 'plan_type',
  FUTURE_ID: 'future_id',
  COLOR: 'color'
};

const HomeType = [
  'condo',
  'townhome',
  'condo and townhome',
  'townhome and condo',
];

const LinkOpenConatactInfo = 'schedule a visit';

const HomeTypeCode = {
  SF: 'Single Family',
  CH: 'Carriage Home',
  PH: 'Patio Home',
  CO: 'Condo',
  TH: 'Townhome',
  TC: 'Townhome and Condo',
};

const Levels = {
  0: 'Lower Level',
  1: 'Main Level',
  2: 'Second Level',
  3: 'Third Level',
  4: 'Fourth Level',
  5: 'Fifth Level',
};

const GlobalEventAction = {
  Unauthorized: 'unauthorized'
} as const

const ACCESS_TOKEN_KEY = "jwt_token"

export { ModalType, OrientationType, StatusCode, Settings, Status, Scalers, TimeSlots,
  DreesCustomHomesAreas, HomePlanSortOptions, SortOptions, SliderChange, QmiDaysFilter,
  OrderHomeTypeList, OrderFooter, UrlFilterList, LinkOpenConatactInfo, HomeType,
  PreAreaNameUrl, FutureData, HomeTypeCode, ImageWidth, Levels, GlobalEventAction,
  ACCESS_TOKEN_KEY, SalesLandFooterOrder, SaleLegendStatusOrder, LandLegendStatusOrder
}